@switch (level) {
  @case (1) {
    <h1 [slim]="slim">
      <ng-container [ngTemplateOutlet]="children"></ng-container>
    </h1>
  }
  @case (2) {
    <h2 [slim]="slim">
      <ng-container [ngTemplateOutlet]="children"></ng-container>
    </h2>
  }
  @case (3) {
    <h3 [slim]="slim">
      <ng-container [ngTemplateOutlet]="children"></ng-container>
    </h3>
  }
  @case (4) {
    <h4 [slim]="slim">
      <ng-container [ngTemplateOutlet]="children"></ng-container>
    </h4>
  }
  @case (5) {
    <h5 [slim]="slim">
      <ng-container [ngTemplateOutlet]="children"></ng-container>
    </h5>
  }
  @case (6) {
    <h6 [slim]="slim">
      <ng-container [ngTemplateOutlet]="children"></ng-container>
    </h6>
  }
}

<span [attr.aria-level]="level" role="heading">
  <ng-container [ngTemplateOutlet]="children"></ng-container>
</span>

<ng-template #children>
  <ng-content></ng-content>
</ng-template>
